import { render, staticRenderFns } from "./my-team.vue?vue&type=template&id=4cff3b3b"
import script from "./my-team.vue?vue&type=script&lang=js"
export * from "./my-team.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports